<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td>
                    <select v-model="form.syear">
                      &nbsp;

                      <option value="099">099</option>

                      &nbsp;

                      <option value="100">100</option>

                      &nbsp;

                      <option value="101">101</option>

                      &nbsp;

                      <option value="102">102</option>

                      &nbsp;

                      <option value="103">103</option>

                      &nbsp;

                      <option value="104">104</option>

                      &nbsp;

                      <option value="105">105</option>

                      &nbsp;

                      <option value="106">106</option>

                      &nbsp;

                      <option value="107">107</option>

                      &nbsp;

                      <option value="108">108</option>

                      &nbsp;

                      <option value="109" selected="selected">109</option>

                      &nbsp;

                      <option value="110">110</option>

                      &nbsp;
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>匯入樣板下載</td>
                  <td>
                    <p>
                      <a
                        href="/PdpsCli/download/F104_1sampple.xlsx"
                        download="sample.xlsx"
                        >sample.xlsx</a
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>匯入名單</td>
                  <td>
                    <input
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      @change="onFileChange"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="匯入"
                          @click="btnQuery()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <PdisFooter />

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.show = false">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex,getMenu } from "@/config/util.js";
import { F104_Import } from "@/service/api.js";
export default {
  name: "F104",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F104",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        syear: new Date().getFullYear() - 1911 - 1,
        updloaD_FILE: "",
      },
      dropDownList: {
        syears: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
  },
  methods: {
    onFileChange: function (event) {
      const self = this;
      self.form.updloaD_FILE = event.target.files[0];
    },
    btnQuery: function () {
      const self = this;
      let formData = new FormData();
      formData.append("UPDLOAD_FILE", self.form.updloaD_FILE);
      formData.append("SYEAR", self.form.syear);
      formData.append("LogInfo.Id",self.loginInfo.id);
      formData.append("LogInfo.PrgCode",self.pageData.PrgName);
      formData.append("LogInfo.ActCd","匯入");
      formData.append("LogInfo.Token",self.loginInfo.token);
      formData.append("LogInfo.ServiceUnit",self.pageData.ServiceUnit);

      F104_Import(formData).then((rData) => {
        if (rData.returnObject.success) {
          self.grid = rData;
          self.Alert.show = true;
          self.Alert.title = "正確";
          self.Alert.txt = [rData.returnObject.message]; // ["匯入成功"];
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.returnObject.message];
        }
      });
    },
    getSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
